if (!global._babelPolyfill) {
    require('babel-polyfill');
}

require(
    __dirname + "/main.scss"
);

import(__dirname + "/patterns/payment-form/payment-form.js");